// Screen vignette levels — pure helper the HUD uses to darken the screen edges as pressure
// rises: a dark edge-vignette that intensifies with swarm threat + dusk, plus the red low-HP
// danger vignette. UI-only (drives two overlay opacities) — no sim/determinism impact.

export interface VignetteLevels {
  /** dark edge-darken opacity (swarm pressure + dusk), 0..~0.7 */
  dark: number
  /** red low-HP danger opacity, 0 (safe) .. ~0.7 (near death) */
  danger: number
}

/**
 * @param threat 0..1 normalized swarm pressure (enemy density)
 * @param cool   0..1 dusk factor (dayLight().cool)
 * @param lowHp  0 (safe) .. 1 (about to die)
 */
export function vignetteLevels(threat: number, cool: number, lowHp: number): VignetteLevels {
  const t = Math.max(0, Math.min(1, threat))
  const c = Math.max(0, Math.min(1, cool))
  const lp = Math.max(0, Math.min(1, lowHp))
  const dark = Math.max(0, Math.min(0.7, t * 0.4 + c * 0.32))
  const danger = lp > 0 ? Math.min(0.7, 0.15 + lp * 0.55) : 0
  return { dark, danger }
}
